module.exports = __webpack_public_path__ + "img/s.58a6f168.png";